import { render, staticRenderFns } from "./arrangement.vue?vue&type=template&id=06c87464&scoped=true"
import script from "./arrangement.vue?vue&type=script&lang=js"
export * from "./arrangement.vue?vue&type=script&lang=js"
import style0 from "./arrangement.vue?vue&type=style&index=0&id=06c87464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c87464",
  null
  
)

export default component.exports